//#region src/variants/variants_progress_circle.js
var variants_progress_circle_default = {
	defaults: { props: {
		size: { tokenCategory: "icon-size" },
		kind: { tokenCategory: "color:d-progress-circle--:--progress-color" }
	} },
	default: { props: {
		progress: { initialValue: 66 },
		ariaLabel: { initialValue: "Upload progress" }
	} },
	"critical at 99% progress": { props: {
		ariaLabel: { initialValue: "Upload progress" },
		progress: { initialValue: 99 },
		size: { initialValue: "800" },
		kind: { initialValue: "critical" }
	} },
	positive: { props: {
		ariaLabel: { initialValue: "Upload progress" },
		progress: { initialValue: 81 },
		size: { initialValue: "600" },
		kind: { initialValue: "positive" }
	} },
	ai: { props: {
		ariaLabel: { initialValue: "Upload progress" },
		progress: { initialValue: 38 },
		size: { initialValue: "400" },
		kind: { initialValue: "ai" }
	} },
	"info at 10% progress": { props: {
		ariaLabel: { initialValue: "Upload progress" },
		progress: { initialValue: 10 },
		size: { initialValue: "400" },
		kind: { initialValue: "info" }
	} },
	"warning at 1% progress": { props: {
		ariaLabel: { initialValue: "Upload progress" },
		progress: { initialValue: 1 },
		size: { initialValue: "400" },
		kind: { initialValue: "warning" }
	} }
};
//#endregion
export { variants_progress_circle_default as default };

//# sourceMappingURL=variants_progress_circle.js.map